import { GzSearchablePolicyPanelViewWebComponent } from './component/GzSearchablePolicyPanelViewWebComponent';

export { GzSearchablePolicyPanelViewWebComponent };
